"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = UserAvatar;

var _avatar = require("./avatar");

var _media = require("react-components/media");

var _acronym = require("@slyk/acronym");

var _imageSources = require("../image-sources");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["imageUrl", "name", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Export `UserAvatar` component.
 */
function UserAvatar(props) {
  var imageUrl = props.imageUrl,
      name = props.name,
      size = props.size,
      rest = _objectWithoutProperties(props, _excluded);

  var imageSources = (0, _imageSources.useImageSources)(imageUrl, '128x');
  return /*#__PURE__*/_react["default"].createElement(_avatar.Avatar, _extends({}, rest, {
    colorTheme: 'gray',
    size: size !== null && size !== void 0 ? size : 'medium'
  }), imageSources ? /*#__PURE__*/_react["default"].createElement(_media.BackgroundImage, imageSources) : (0, _acronym.getAcronym)(name));
}